var app = angular.module('leonardo');

var DynamicFormCreatorFilter = function (AuthDataService) {
  return function (dynamic_form) {
    if (dynamic_form.origin === 'account') {
      if (dynamic_form.account) {
        return 'A';
      }
      return (AuthDataService.isAdmin() && dynamic_form.client_instance ? 'CI' : 'S');
    }
    else {
      return AuthDataService.isAdmin() && dynamic_form.client_instance ? 'CI' : 'S';
    }
  };
};

var DynamicFormCreatorDescriptionFilter = function (AuthDataService) {
  return function (dynamic_form) {
    if (dynamic_form.origin === 'account') {
      if (dynamic_form.account) {
        return 'Account';
      }
      return (AuthDataService.isAdmin() && dynamic_form.client_instance ? 'Client Instance' : 'System');
    }
    else {
      return AuthDataService.isAdmin() && dynamic_form.client_instance ? 'Client Instance' : 'System';
    }
  };
};

app.filter('dynamicFormCreator', ['AuthDataService', DynamicFormCreatorFilter]);
app.filter('dynamicFormCreatorDescription', ['AuthDataService', DynamicFormCreatorDescriptionFilter]);
